import { ColumnDef } from '@tanstack/react-table';
import { Button } from '@/components/ui/button';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { Container } from 'src/trpc';
import { StatusDisplay } from 'components/StatusDisplay';
import { NumericFormat } from 'react-number-format';

export const ContainerColumns: ColumnDef<Container>[] = [
  {
    accessorKey: 'friendlyId',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Dumpster ID
          {!column.getIsSorted() && <ArrowUpDown className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'asc' && <ArrowUp className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'desc' && <ArrowDown className="ml-2 h-4 w-4" />}
        </Button>
      );
    },
    cell: ({ cell }) => {
      const value = cell.getValue() as string;
      return (
        <div className="w-fit">
          <span className="underline">{value}</span>{' '}
        </div>
      );
    },
  },
  {
    accessorKey: 'containerTypeInfo.name',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Name
          {!column.getIsSorted() && <ArrowUpDown className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'asc' && <ArrowUp className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'desc' && <ArrowDown className="ml-2 h-4 w-4" />}
        </Button>
      );
    },
  },
  {
    accessorKey: 'containerTypeInfo.pricePerDay',
    header: 'Price Per Day',
    cell: ({ cell }) => {
      return (
        <div className="w-fit">
          $
          <NumericFormat
            thousandSeparator
            displayType="text"
            value={(cell.getValue() as number) / 100}
            allowedDecimalSeparators={['.']}
          />
        </div>
      );
    },
  },
  {
    accessorKey: 'containerTypeInfo.maxWeight',
    header: 'Max Weight',
    cell: ({ cell }) => (
      <div className="w-fit">
        <NumericFormat thousandSeparator displayType="text" value={cell.getValue() as number} /> Lbs
      </div>
    ),
  },
  {
    accessorKey: 'containerTypeInfo.volume',
    header: 'Volume',
  },
  {
    accessorKey: 'status',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Status
          {!column.getIsSorted() && <ArrowUpDown className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'asc' && <ArrowUp className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'desc' && <ArrowDown className="ml-2 h-4 w-4" />}
        </Button>
      );
    },
    cell: ({ row }) => (
      <div className="w-fit">
        <StatusDisplay status={row.getValue('status')} />
      </div>
    ),
  },
];
